<template>
    <router-view/>
</template>

<script>
    import tokenService from "../../service/tokenService";

    export default {
        name: "EventLayout",
        beforeRouteEnter(to, from,next) {
            let curToken = tokenService.getToken();
            if (to.name !== 'Signin' && !tokenService.isTokenValid(curToken)) next({ name: 'Signin' })
            else next()
        },
        created() {
        },
    }
</script>

<style scoped>

</style>